var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{class:['line_item', {'is-result': _vm.isResult}]},[_c('span',{staticClass:"line_item--label text-uppercase"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('span',{staticClass:"line_item--value"},[_vm._v(_vm._s(_vm.valueAmount)+_vm._s(_vm.time ? ' x ' + _vm.time + ' mo' : ''))])])
}
var staticRenderFns = []

export { render, staticRenderFns }